import { render, staticRenderFns } from "./EditBase.vue?vue&type=template&id=a9481d60&scoped=true"
import script from "./EditBase.vue?vue&type=script&lang=js"
export * from "./EditBase.vue?vue&type=script&lang=js"
import style0 from "./EditBase.vue?vue&type=style&index=0&id=a9481d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9481d60",
  null
  
)

export default component.exports